import { ModalActionTypes } from '@acorns/web-components'

const ssnHasAlreadyBeenUsed = graphQLErrors => {
  return graphQLErrors?.[0]?.extensions?.response?.body?.error ?? []
}

export const setupErrorModal = (closeErrorModal, graphQLErrors) => {
  let errorDetails = {}
  if (ssnHasAlreadyBeenUsed(graphQLErrors)) {
    errorDetails = {
      actions: [
        {
          label: 'Okay',
          handler: () => {
            closeErrorModal()
          },
          type: ModalActionTypes.primary,
        },
      ],
      message:
        'There was an issue with your SSN. Please double check your entry or contact support.',
      title: 'Uh-Oh',
    }
  }
  return errorDetails
}
